import { Injectable, signal } from '@angular/core';

export interface CommentSentEvent {
  referenceId: string | number;
  referenceInternalId?: number;
  referenceUid?: string | number;
  configTypeId: string;
  applicationId: string;
  siteId?: number;
  external: boolean;
  postId?: string | number;
  commentId?: number;
  commentsTotal?: number;
  timestamp: number;
}

@Injectable({ providedIn: 'root' })
export class SvcCommentsEventsService {
  private _lastEvent = signal<CommentSentEvent | null>(null);
  public lastEvent = this._lastEvent.asReadonly();

  public emitCommentSent(event: Omit<CommentSentEvent, 'timestamp'>): void {
    const payload = { ...event, timestamp: Date.now() };
    this._lastEvent.set(payload);
  }
}
